import DPR from './DPR.js'

export default class Background {
  constructor() {
    this._elCanvas = document.querySelector('#backCanvas');
    this._ctx = this._elCanvas.getContext('2d');
    this._marks = 'PixelArch'.split('');
    this._offsetCount = 0;
    this._parallaxImgs = {};
    this._parallaxHeights = {};
    this._isStatic = false;
  }
  set(type, props) {
    if('_destruct_' + this._type in this) {
      this['_destruct_' + this._type]();
    }
    this._type = type;
    this._props = props ?? {};
    if('_construct_' + this._type in this) {
      this['_construct_' + this._type]();
    }
    if(this._isStatic) {
      this['_draw_' + this._type](this._offsetCount);
    } else {
      this._callDraw();
    }
  }
  setStatic(isStatic) {
    this._isStatic = isStatic;
    if(isStatic) {
      clearInterval(this._intervalID);
      this._intervalID = 0;
      this['_draw_' + this._type](this._offsetCount);
    } else {
      this._callDraw();
    }
  }
  _callDraw() {
    clearInterval(this._intervalID);
    this._intervalID = setInterval(() => {
      this['_draw_' + this._type](this._offsetCount++);
    }, 80);
  }
  _draw_checker(offsetCount) {
    const {width, height} = this._elCanvas;
    const color1 = document.documentElement.style.getPropertyValue('--color-background');
    const color2 = document.documentElement.style.getPropertyValue('--color-background2');
    const unit = Math.floor(10 * height / 100);
    const offset = offsetCount % unit;

    this._ctx.fillStyle = color2;
    this._ctx.fillRect(0, 0, width, height);

    this._ctx.fillStyle = color1;
    for(let y = -1; y < Math.ceil(height / unit); ++y) {
      const yIsEven = Boolean(y % 2);
      for(let x = -1; x < Math.ceil(width / unit); ++x) {
        const xIsEven = Boolean(x % 2);
        if(yIsEven === xIsEven) {
          this._ctx.fillRect(offset + x * unit, offset + y * unit, unit, unit);
        }
      }
    }
  }
  _draw_character(offsetCount) {
    const {width, height} = this._elCanvas;
    const color1 = document.documentElement.style.getPropertyValue('--color-background');
    const color2 = document.documentElement.style.getPropertyValue('--color-background2');
    const unit = Math.floor(10 * height / 100);
    const offset = offsetCount % unit;

    this._ctx.fillStyle = color2;
    this._ctx.fillRect(0, 0, width, height);

    this._ctx.fillStyle = color1;
    this._ctx.font = `${unit}px sans-serif`;
    this._ctx.textAlign = 'center';
    this._ctx.textBaseline = 'middle';
    const character = this._props.character;
    for(let y = -2; y < Math.ceil(height / unit); ++y) {
      const yIsEven = Boolean(y % 2);
      for(let x = -2; x < Math.ceil(width / unit); ++x) {
        const xIsEven = Boolean(x % 2);
        if(yIsEven === xIsEven) {
          this._ctx.fillText(character, offset + x * unit + unit / 2, offset + y * unit + unit * 2 / 3);
        }
      }
    }
  }
  _construct_parallax() {
    const {name} = this._props;
    if(!(name in this._parallaxImgs)) {
      this._parallaxImgs[name] = null;
      fetch(`./images/${name}.png`).then(res => res.blob()).then(blob => createImageBitmap(blob)).then(ib => {
        this._parallaxImgs[name] = ib;
        this._draw_parallax(this._offsetCount);
      }).catch(() => {
        delete this._parallaxImgs[name];
      });
    }

    const {width: canvasWidth, height: canvasHeight} = this._ctx.canvas;
    this._ctx.fillStyle = document.documentElement.style.getPropertyValue('--color-background');
    this._ctx.fillRect(0, 0, canvasWidth, canvasHeight);
  }
  _draw_parallax(offsetCount) {
    const {_ctx, _parallaxImgs} = this;
    const {width: canvasWidth, height: canvasHeight} = _ctx.canvas;
    const {name, widths, speeds} = this._props;
    const img = _parallaxImgs[name];

    if(img) {
      _ctx.imageSmoothingEnabled = false;
      const {width: imgWidth, height: imgHeight} = img;
      const scale = canvasHeight / imgHeight;
      let srcX = imgWidth;
      for(let i = widths.length - 1; 0 <= i; --i) {
        const width = widths[i];
        srcX -= width;
        const imgScaledWidth = Math.floor(width * scale);
        const startX = -Math.floor(offsetCount * speeds[i]) % imgScaledWidth;
        for(let x = startX; x < canvasWidth; x += imgScaledWidth) {
          const src = [srcX, 0, width, imgHeight];
          const dst = [x, 0, imgScaledWidth, canvasHeight];
          _ctx.drawImage(img, ...src, ...dst);
        }
      }
    }
  }
  resize(width, height) {
    this._elCanvas.width = width;
    this._elCanvas.height = height;
    if(this._isStatic) {
      this['_draw_' + this._type](this._offsetCount);
    }
    this._elCanvas.style.transform = `scale(${DPR.div(1)})`;
  }
}
